// Filtros de shape específico da navbar nav2026 (grupos {title, items} de
// buildGestaoGroups) pra regra do escritório Fee Fixo Migração. A decisão de
// QUEM cai nessa regra vive em @utils/escritorioFeeFixoMigracao (compartilhada
// com o guard do router, `src/router/index.js`) — este arquivo só sabe
// filtrar o shape da navbar, não decide quem é afetado.
import { routeModuleKey } from '@modules/navegacao-v2/utils/visible-modules'

// Além do próprio Fee Fixo: CRM, Financial Planning (`fp`) e AAWZ Intelligence
// — liberados por pedido do usuário (12/08/2026). Mesma lista que
// `MODULE_KEYS_LIBERADOS_FEE_FIXO_MIGRACAO` em `src/router/index.js` — as
// duas precisam mudar juntas. `Set` (não Array): uso é só existência via
// `.has()` (SonarQube javascript:S7776, review do PR #1940).
const MODULE_KEYS_PERMITIDOS = new Set([
  'fee-fixo',
  'crm',
  'fp',
  'aawz-intelligence',
])

const soPermitidos = (items) =>
  (items || []).filter((item) =>
    MODULE_KEYS_PERMITIDOS.has(routeModuleKey(item.routeName))
  )

// Filtra a lista de grupos ({title, items}) da sidebar de gestão, mantendo só
// os itens permitidos; grupo que fica sem item nenhum é descartado.
export const filtrarGruposSoFeeFixo = (groups) =>
  (groups || [])
    .map((group) => ({ ...group, items: soPermitidos(group.items) }))
    .filter((group) => group.items.length)

// Filtra uma lista plana de itens (ex: topItems) pelo mesmo allowlist.
export const filtrarItensSoFeeFixo = (items) => soPermitidos(items)
